import { ORGANIZATIONS_LOGO_URL } from '../constants/environment';

const META_SEPARATOR = ' · ';

/**
 * "Lebanon, NH". The payload may carry none of these fields — callers must
 * tolerate an empty string.
 * @param {{ city?: string, state?: string, location?: string }} organization
 */
export const getOrganizationLocation = ({ city, state, location } = {}) =>
  location || [city, state].filter(Boolean).join(', ');

/**
 * "Lebanon, NH · Adult acute care" — location and department, dropping
 * whichever part is missing.
 * @param {{ city?: string, state?: string, location?: string, department?: string }} organization
 */
export const getOrganizationMeta = (organization = {}) =>
  [getOrganizationLocation(organization), organization.department]
    .filter(Boolean)
    .join(META_SEPARATOR);

/**
 * Logo candidates in priority order; callers fall through on load error and
 * hide the image when both fail (organizations without a logo are common).
 * @param {{ logo?: string }} organization
 * @param {'web' | ''} [variant]
 */
export const getOrganizationLogoUrls = ({ logo } = {}, variant = 'web') =>
  logo
    ? [
        `${ORGANIZATIONS_LOGO_URL}${variant ? `${variant}/` : ''}${logo}`,
        `${ORGANIZATIONS_LOGO_URL}${logo}`,
      ]
    : [];
